import { render, staticRenderFns } from "./ModelUpload.vue?vue&type=template&id=56035988&scoped=true"
import script from "./ModelUpload.vue?vue&type=script&lang=ts"
export * from "./ModelUpload.vue?vue&type=script&lang=ts"
import style0 from "./ModelUpload.vue?vue&type=style&index=0&id=56035988&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56035988",
  null
  
)

export default component.exports